import 'phaser'
import { l } from '../lib/imports'
import { asteroids } from './asteroids-sidecar'
import { IAsteroidType } from './asteroidsData'
import { scene } from '../main/scene-sidecar'

export interface IAsteroidSaved {
  type: IAsteroidType
  i: number
  j: number
  supplyLeft: number
}

export function save() {
  let sd: IAsteroidSaved[] = []

  let objs = asteroids.getAll()
  l.forEach(objs, (c) => {
    sd.push({
      i: c.i,
      j: c.j,
      type: c.data.type,
      supplyLeft: c.supplyLeft,
    })
  })

  return sd
}

export function load(sd: IAsteroidSaved[]) {
  let ctx = scene.getContext()
  l.forEach(sd, (c) => {
    let obj = asteroids.create(c.type)
    asteroids.moveToTile(obj, ctx.mapShip, c.i, c.j)
    obj.supplyLeft = c.supplyLeft
  })
}
